import "src/core";
import "./global.css";
import { BoundaryNames } from "src/shared/utils/sentry/BoundaryNames";
import { ViagogoAppEntrypoint } from "src/website-apps/shared/components/viagogo-app-entrypoint/viagogo-app-entrypoint";
import { App } from "./components/App";

export const HomeRoot = () => (
  <ViagogoAppEntrypoint boundaryName={BoundaryNames.HOME}>
    <App />
  </ViagogoAppEntrypoint>
);
